var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{ref:"wrapper",staticClass:"text-animated",class:{ animated: _vm.isVisible }},_vm._l((_vm.text.split(' ')),function(word,i){return _c('span',{key:`word-${i}`},[_c('span',{style:(`transition-delay: ${i * 50}ms`)},[_vm._v(_vm._s(word)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }